import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { CaseType, WalletType } from '~/shared';
import { CaseItem, CaseType as CaseTypes, calcOldPrice } from '../CaseItem';
import { CasePromotionBanner } from '../CasePromotionBanner';
import {
	StyledCasesContainer,
	StyledCategory,
	StyledCategoryItem,
	StyledContainer,
	StyledKitsContainer,
	StyledRightContainer,
} from './ShopMain.styled';

const ShopMain = () => {
	const cases = useObservable(rage.cases.getLootboxes());
	const bundles = useObservable(rage.cases.getBundles());

	return (
		<StyledContainer $banner>
			<CasePromotionBanner />
			<StyledRightContainer>
				<StyledCategoryItem>
					<StyledCategory>
						<Text>НОВЫЕ КЕЙСЫ</Text>
					</StyledCategory>
					<StyledCasesContainer>
						{cases.map((item, index) => (
							<CaseItem
								id={item.id}
								name={item.name}
								type={
									rage.cases.getCaseTypeById(item.id) === CaseType.CASE
										? CaseTypes.Default
										: CaseTypes.Kit
								}
								image={item.id}
								discount={item.discount ?? 0}
								price={item.price ?? 0}
								wallet={item.walletType as WalletType.Cash | WalletType.Donate}
								oldPrice={calcOldPrice(item.price ?? 0, item.discount ?? 0)}
								key={index}
								tags={item.tags}
								dateDiscountEnd={item.discountTimestampEnd}
								dateEnd={item.enabledTimestampEnd}
							/>
						))}
					</StyledCasesContainer>
				</StyledCategoryItem>
				<StyledCategoryItem>
					<StyledCategory>
						<Text>НОВЫЕ НАБОРЫ</Text>
					</StyledCategory>
					<StyledKitsContainer>
						{bundles.map((item, index) => (
							<CaseItem
								id={item.id}
								name={item.name}
								type={CaseTypes.Kit}
								image={item.id}
								discount={item.discount ?? 0}
								price={item.price ?? 0}
								wallet={item.walletType as WalletType.Cash | WalletType.Donate}
								oldPrice={calcOldPrice(item.price ?? 0, item.discount ?? 0)}
								key={index}
								tags={item.tags}
								dateDiscountEnd={item.discountTimestampEnd}
								dateEnd={item.enabledTimestampEnd}
								span={2}
							/>
						))}
					</StyledKitsContainer>
				</StyledCategoryItem>
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { ShopMain };
